import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=b2454448&scoped=true&"
import script from "./welcome.vue?vue&type=script&lang=ts&"
export * from "./welcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2454448",
  null
  
)

export default component.exports